// Design System Colors: the Northern Mint sheet for JRAT'S Studio
export const COLORS = {
  // The three sheet colours, verbatim
  MINT: '#2bc48a',      // Mint Leaf
  NAVY: '#0d1b2a',      // Deep Navy
  PLATINUM: '#e6e9ec',  // Platinum

  // Derived so the system has enough range
  PINE: '#0b7a55',      // Mint Leaf darkened until it reads as text on white
  SLATE: '#1d3b52',     // Deep Navy lifted, for lines inside the dark stage

  BLACK: '#000000',
  WHITE: '#ffffff',

  // Semantic aliases for the two grounds
  INK: '#0d1b2a',
  PAPER: '#e6e9ec',
} as const;

/**
 * Logo inks for contexts that cannot read CSS custom properties (the share card is drawn
 * by Satori, the favicon and webp are generated by a script). globals.css carries the same
 * two values as --brand-logo-wordmark and --brand-logo-studio; change both together.
 */
export const LOGO = {
  WORDMARK: COLORS.NAVY,
  STUDIO: COLORS.PINE,
} as const;

// Contact / conversion
const CONSULT_SUBJECT = "Book a slot with JRAT'S Studio";
const CONSULT_BODY = [
  "Hi JRAT'S team,",
  "",
  "I'd like to book a call.",
  "",
  "What we're building: ",
  "What's slowing us down: ",
  "Best time for a call: ",
].join("\n");

export const CONTACT = {
  EMAIL: 'hello@jrats.studio',
  /** Pre-filled email. Stays the fallback whenever the scheduler is off or its widget cannot load. */
  CONSULT_HREF: `mailto:hello@jrats.studio?subject=${encodeURIComponent(CONSULT_SUBJECT)}&body=${encodeURIComponent(CONSULT_BODY)}`,
  /**
   * Google Calendar appointment schedule behind every booking CTA (see lib/booking.ts).
   * Leave NEXT_PUBLIC_BOOKING_URL unset (or empty) and every CTA falls back to the
   * pre-filled email.
   *
   * NEXT_PUBLIC_ vars are inlined at build time, so a change needs a rebuild, not just a
   * restart of the running server.
   */
  BOOKING_URL: process.env.NEXT_PUBLIC_BOOKING_URL?.trim() ?? '',
} as const;

// Z-Index and Timing constants removed (unused)
